const strContains = (firstStr, secondStr) => {
    return firstStr.toLowerCase().includes(secondStr.toLowerCase())
    ? true
    : false


}
export default strContains